import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import { useMemo } from 'react';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';

interface TemplateProps extends SelectProps<number> {
    filterList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { filterList = [], ...restProps } = props;

    const options = useMemo(() => {
        let _options: {
            label: string;
            value: number;
        }[] = Udesk.enums.inspectDataSources.map((d) => {
            return {
                label: Udesk.enums.inspectDataSources.getName(d.id),
                value: d.id,
            };
        });

        if (filterList.length) {
            _options = _options.filter((o) => filterList.includes(o.value));
        }

        return _options;
    }, [filterList]);

    return <Select options={options} {...restProps} />;
});

export default Template;
